import styled from 'styled-components';
import ICON_24 from '@/assets/korUploadFile/icon_24.png';
import { Icon } from '@successmode-ktp/kui';

type Props = {
  onClick: () => void;
};

const MoveToGov = ({ onClick }: Props) => {
  return (
    <Button onClick={onClick}>
      <TextWrapper>
        <img src={ICON_24} alt='' width={24} />
        정부24 이동하기
      </TextWrapper>
      <Icon.ChevronRight />
    </Button>
  );
};
export default MoveToGov;

const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--KTP-Grayscale-Gray_12, #f4f4f4);
  background: var(--KTP-Grayscale-Gray_13, #fafafa);
  box-shadow: 1px 2px 4px 0px rgba(80, 80, 80, 0.25);
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
